
import React, { useState } from "react";
import logo from "../../../src/images/Logo.webp";
import { IoMenu } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { NavLink } from "react-router-dom";
import { IoCloseCircle } from "react-icons/io5";
import { useSelector } from "react-redux";
import FormModal from "../Common/FormModal"
const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
   const formmodal = useSelector((state) => state.Globalslice.formmodal);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };
const topclick = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

  return (
    <div className="HeaderMain ">
      <div className="globalbaody Header">
        <NavLink to="/" onClick={topclick}>
          <img loading="lazy" src={logo} alt="Logo" className="logo" />
        </NavLink>

        {/* Desktop Header Content */}
        <div className="header-rightcontent">
          <NavLink
            to="/who-we-are"
            className={({ isActive }) =>
              isActive ? "Header-right-titles text-decoration-none active-link" : "Header-right-titles text-decoration-none"
            }
          >
            Who we are
          </NavLink>
          {/* <NavLink
          to="/what-we-do"
          className={({ isActive }) =>
            isActive ? "Header-right-titles text-decoration-none active-link" : "Header-right-titles text-decoration-none"
          }
        >
          What we do
        </NavLink> */}
          <NavLink
            to="/get-involved"
            className={({ isActive }) =>
              isActive ? "Header-right-titles text-decoration-none active-link" : "Header-right-titles text-decoration-none"
            }
          >
            Get involved
          </NavLink>
          {/* <NavLink
            to="/media"
            className={({ isActive }) =>
              isActive ? "Header-right-titles text-decoration-none active-link" : "Header-right-titles text-decoration-none"
            }
          >
            Media
          </NavLink> */}
        </div>

        {/* Mobile Menu Button */}
        <div className="mobile-menu" onClick={toggleSidebar}>
          {isSidebarOpen ? <IoCloseCircle className="sidebaricon" size={40} /> : <IoMenu className="sidebaricon"  size={40} />}
        </div>

        {/* Sidebar for Mobile */}
        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
      
          <div className="sidebar-content">
          <NavLink to="/" className="mt-1 mb-4" onClick={closeSidebar}>
          <img loading="lazy" src={logo} alt="Logo" className="logo" />
        </NavLink>
            <NavLink
              to="/who-we-are"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-link text-decoration-none" : "sidebar-item text-decoration-none"
              }
              onClick={closeSidebar}
            >
              Who we are
            </NavLink>
            {/* <NavLink
            to="/what-we-do"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-link text-decoration-none" : "sidebar-item text-decoration-none"
            }
            onClick={closeSidebar}
          >
            What we do
          </NavLink> */}
            <NavLink
              to="/get-involved"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-link text-decoration-none" : "sidebar-item text-decoration-none"
              }
              onClick={closeSidebar}
            >
              Get involved
            </NavLink>
            {/* <NavLink
              to="/media"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-link text-decoration-none" : "sidebar-item text-decoration-none"
              }
              onClick={closeSidebar}
            >
              Media
            </NavLink> */}
          </div>
        </div>
      </div>
      {
        formmodal &&   <FormModal/>
      }
    
    </div>

  );
};

export default Header;

